import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var TrendDown01 = function TrendDown01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m22 17-7.8686-7.8686c-.396-.396-.5941-.594-.8224-.6682a1 1 0 0 0-.618 0c-.2283.0741-.4264.2721-.8224.6682l-2.7372 2.7372c-.396.396-.594.5941-.8224.6682a1 1 0 0 1-.618 0c-.2283-.0741-.4264-.2722-.8224-.6682L2 7m20 10h-7m7 0v-7"
    })
  }));
};
export default TrendDown01;